import { render } from "./DriverCreatePage.vue?vue&type=template&id=46f74392"
import script from "./DriverCreatePage.vue?vue&type=script&lang=js"
export * from "./DriverCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__